<template>
    <div class="data-permission">
        <div class="content">
            <div class="content-search">
                <div class="search-input">
                    <el-input v-model="searchData"
                              @keyup.enter.native="handleSearchData"
                              size="mini"
                              placeholder="请输入内容"
                              class="search-input-item">
                    </el-input>
                    <el-button type="primary" @click="handleSearchData">查 询</el-button>
                    <el-checkbox class="has-Check" v-if="manage" v-model="hasChecked" @change="handleHasPermission">已有权限</el-checkbox>
                </div>
                <el-button type="primary" class="save-button" @click="handleSaveData" :loading="saveLoading">保 存</el-button>
                <el-checkbox v-if="row.userType === '1'" v-show="false" class="select-all" v-model="checkedAll" style="color: red;">分配所有数据权限</el-checkbox>
            </div>
            <div class="content-checkbox">
                    <el-checkbox class="checkbox-item" v-for="item in totalData"
                                 :key="item.authCode"
                                 v-model="item.selectedFlag"
                                 @change="handleChangecheckbox"
                                 :label="item.authCode">{{item.authName}}
                    </el-checkbox>
                <div v-if="!totalData.length" class="empty-text">暂无数据</div>
            </div>

        </div>
        <div class="page">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange" class="check-all">全选</el-checkbox>
            <mPage :total="total"
                   :currentPage="currentPage"
                   :pageData="pageData"
                   @on-size-change="handleSizeChange"
                   @on-page-change="handleCurrentChange">
            </mPage>
        </div>
    </div>
</template>
<script>
import mPage from '@/components/otpPanel/mPage/Main.vue';
import { pageTag } from '../../../../../../constant/constant.js';
import { getAllDataAuth, getDataAuthsFromGrant, submitData, getAllDataAuthOfWorkbench } from '../../../../../../api/register/person.js';

export default {
    inheritAttrs: false,
    name: 'data-permission',
    components: { mPage },
    props: {
        dataCode: {
            type: String,
            default() {
                return '';
            }
        },
        row: {
            type: Object,
            default() {
                return {};
            }
        },
        manage: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            saveLoading: false,
            total: 0,
            currentPage: 1,
            pageData: pageTag,
            searchData: '',
            checkAll: false,
            hasChecked: false,
            checkedAll: false,
            totalData: [],
            searchObj: {}
        };
    },
    mounted() {},
    methods: {
        handleSizeChange(data) {
            this.pageData.pageSize = data;
            this.handleGetDataAuths(this.searchObj);
        },
        handleCurrentChange(data) {
            this.currentPage = data;
            this.handleGetDataAuths(this.searchObj);
        },
        handleHasPermission(value) {
            // 已有权限
            this.currentPage = 1;
            this.handleGetDataAuths();
        },
        handleCheckAllChange(isCheckedAll) {
            this.totalData = this.totalData.map(item => {
                item.selectedFlag = !!isCheckedAll;
                return item;
            });
        },
        handleChangecheckbox(val) {
            this.checkAll = this.totalData.every(item => {
                return item.selectedFlag;
            });
        },
        judgeMainOrSub() {
            if (this.row.userType === '1') { // 主账号
                return true;
            }
            if (this.row.userType === '2') { // 子账号
                return false;
            }
        },
        handleSaveData() {
            this.saveLoading = true;
            const params = this.handleSubmitData();
            submitData(JSON.stringify(params)).then(res => {
                if (res && res.code === '0') {
                    this.saveLoading = false;
                    this.$message.success('保存成功！');
                }
            });
        },
        handleSearchData() {
            this.currentPage = 1;
            this.searchObj.search = this.searchData;
            this.handleGetDataAuths(this.searchObj);
        },
        /** 处理工作台主账号、工作台子账号、管理端子账号、请求返回数据 **/
        handleShowData(res) {
            this.totalData = [];
            this.totalData = res.data.list.map(item => {
                item.selectedFlag = !!item.selectedFlag;
                return item;
            });
            this.total = res.data.totalCount;
            this.checkedAll = !!res.data.allFlag;
            this.$nextTick(() => {
                if (res.data.list.length) {
                    this.checkAll = res.data.list.every(item => {
                        return item.selectedFlag;
                    });
                } else {
                    this.checkAll = false;
                }
            });
        },
        getMainUserListOfWorkbench(params) {
            params.supplierCode = this.$store.state.supplier ? this.$store.state.supplier.supplierCode : '';
            getAllDataAuthOfWorkbench(params).then(res => {
                if (res && res.data && res.code === '0') {
                    this.handleShowData(res);
                }
            });
        },
        getMainUserList(params) {
            params.supplierCode = this.row.userCode;
            getAllDataAuth(JSON.stringify(params)).then(res => {
                if (res && res.data && res.code === '0') {
                    this.totalData = [];
                    this.totalData = res.data.userDataAuthDtos.list.map(item => {
                        item.selectedFlag = !!item.selectedFlag;
                        return item;
                    });
                    this.total = res.data.userDataAuthDtos.totalCount;
                    this.checkedAll = !!res.data.allFlag;
                    this.$nextTick(() => {
                        if (res.data.userDataAuthDtos.list.length) {
                            this.checkAll = res.data.userDataAuthDtos.list.every(item => {
                                return item.selectedFlag;
                            });
                        } else {
                            this.checkAll = false;
                        }
                    });
                }
            });
        },
        getSubUserList(params) {
            params.supplierCode = this.$store.state.supplier ? this.$store.state.supplier.supplierCode : this.row.userCode;
            getDataAuthsFromGrant(JSON.stringify(params)).then(res => {
                if (res && res.data && res.code === '0') {
                    this.handleShowData(res);
                }
            });
        },
        handleGetDataAuths(searchObj = {}, params = { pageSize: this.pageData.pageSize, pageNo: this.currentPage }) {
            searchObj.userCode = this.row.userCode;
            searchObj.dataCode = this.dataCode;
            params = Object.assign(params, searchObj);
            if (this.judgeMainOrSub()) {
                // 管理端主账号
                if (this.manage) {
                    params.selectedFlag = this.hasChecked ? 1 : null;
                    this.getMainUserList(params);
                } else {
                    // 工作台主账号
                    params.selectedFlag = 1;
                    params.sourceUserCode = this.row.userCode;
                    this.getMainUserListOfWorkbench(params);
                }
            } else {
                // 子账号、管理端和工作台调的接口相同
                params.selectedFlag = this.hasChecked ? 1 : null;
                this.getSubUserList(params);
            }
        },
        handleSubmitData() {
            const form = {};
            const tempArr = JSON.parse(JSON.stringify(this.totalData));
            form.userCode = this.row.userCode;
            if (this.judgeMainOrSub()) {
                form.allFlag = this.checkedAll ? 1 : 0;
            } else {
                form.allFlag = 0;
            }
            form.dataCode = this.dataCode;
            form.data = tempArr.map(item => {
                item.selectedFlag = +item.selectedFlag;
                item.tenantCode = this.$store.state.currentTenant.tenantCode;
                return item;
            });
            // 取消全选权限
            if (!this.checkedAll) {
                form.data.push({
                    authCode: 'ALL',
                    userCode: this.row.userCode,
                    authName: 'ALL',
                    dataCode: this.dataCode,
                    tenantCode: this.$store.state.currentTenant.tenantCode,
                    selectedFlag: 0
                });
            }
            return form;
        }
    },
    computed: {
        codes() {
            return this.dataCode + this.row.userCode;
        }
    },
    watch: {
        codes: {
            handler() {
                if (this.row.userCode) {
                    this.handleGetDataAuths();
                } else {
                    this.total = 0;
                    this.currentPage = 1;
                    this.pageData = pageTag;
                    this.searchData = '';
                    this.hasChecked = false;
                    this.checkAll = false;
                    this.checkedAll = false;
                    this.totalData = [];
                    this.searchObj = {};
                }
            },
            immediate: true
        },
        row: {
            handler() {
                pageTag.pageSize = 10;
                this.pageData = pageTag;
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
<style lang="less">
    .data-permission {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        .content {
            height: 90%;
            width: 100%;
            margin-bottom: 2%;
            box-sizing: border-box;
            overflow-y: auto;
            border-bottom: 1px solid #e9e9e9;
        }
        .page {
            height: 5%;
            width: 100%;
            box-sizing: border-box;
            padding-right: 20px;
            line-height: 27px;
        }
        .search-input {
            width: 60%;
            height: 30px;
            float: left;
            line-height: 30px;
            .search-input-item {
                width: 58%;
                float: left;
                margin-right: 10px
            }
            .has-Check {
                margin-left: 20px;
            }
        }
        .select-all {
            line-height: 30px;
            float: right;
            margin-right: 30px;
        }
        .content-search {
            height: 30px;
            width: 100%;
            .save-button {
                float: right;
            }
        }
        .content-checkbox {
            position: relative;
            height: calc(100% - 30px);
            width: 100%;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            align-content: flex-start;
            flex-wrap: wrap;
            overflow-y: auto;
            padding-top: 10px;
            .checkbox-item {
                width: 350px;
                height: 28px;
                margin: 5px 0 0 10px;
                & .el-checkbox__label {
                    width: 300px;
                }
            }
            .empty-text {
                width: 100%;
                height: 100%;
                text-align: center;
                line-height: 460px;
                color: #898C8C;
            }
        }
    }
</style>
